import { z } from 'zod';
import { availabilityValues } from './partner-worker.dto';

const partnerWorkerSchema = z.object({
  id: z.string(),
  shiftClaimId: z.string().optional(),
  name: z.string(),
  hasRequiredCertificates: z.boolean(),
  partnerName: z.string(),
  email: z.string(),
  phone: z.string(),
  availability: z.enum(availabilityValues),
  workedMinutes: z.number().optional().nullable(),
  contractMinutes: z.number().optional().nullable(),
});

export const partnerWorkerInfiniteQueryResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  items: z.array(partnerWorkerSchema),
});

export type PartnerWorkerInfiniteQueryResponse = z.infer<
  typeof partnerWorkerInfiniteQueryResponseSchema
>;

export type PartnerWorker = z.infer<typeof partnerWorkerSchema>;
